// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileTabletBrochureForm_container__bFRsk {
    display: flex;
    flex-direction: column;
}

.MobileTabletBrochureForm_input__krJeL {
    background-color: transparent;
    border-radius: 16px;
    border: 1.5px solid var(--primary-light-01);
    padding: 16px 20px;
    outline: none;
    font-size: var(--font-size-8);
    color: var(--primary-light);
    font-family: var(--font-medium), sans-serif;
    transition: border-color 0.3s ease-out;
    flex-grow: 1;
}

.MobileTabletBrochureForm_input__krJeL:focus {
    border-color: var(--primary-accent);
}

.MobileTabletBrochureForm_inputWrapper__RF3CZ {
    background-color: transparent;
    border-radius: 16px;
    border: 1.5px solid var(--primary-dark);
    display: flex;
    align-items: center;
}

.MobileTabletBrochureForm_selectWrapper__bcelS {
    background-color: transparent;
    border-radius: 16px;
    border: 1.5px solid var(--primary-dark);
    padding: 16px 20px;
    display: flex;
    align-items: center;
}

.MobileTabletBrochureForm_focused__gVllA {
    border-color: var(--primary-accent);
    transition: border-color 0.3s ease-out;
}

.MobileTabletBrochureForm_select__0rWP6 {
    background-color: transparent;
    outline: none;
    font-size: var(--font-size-8);
    border: none;
    width: 100%;
    color: var(--primary-light);
    font-family: var(--font-medium), sans-serif;
}

.MobileTabletBrochureForm_rtl__Uiad5 {
    direction: rtl;
}

.MobileTabletBrochureForm_formButton__FrU4- {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: var(--primary-light);
    font-family: var(--font-semi-bold), sans-serif;
    font-size: var(--font-size-5);
    background-color: var(--primary-accent);
    border-radius: 50px;
    padding: 16px 20px;
    cursor: pointer;
    transition: all 0.3s ease-out;
}

.MobileTabletBrochureForm_formButton__FrU4-:hover,
.MobileTabletBrochureForm_formButton__FrU4-:active {
    background-color: var(--primary-accent-08);
}

.MobileTabletBrochureForm_tabletRow__aVJQa {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
}

.MobileTabletBrochureForm_tabletRow__aVJQa > div {
    width: 49%;
    display: flex;
    flex-direction: column;
}

.MobileTabletBrochureForm_error__fuYyp {
    font-size: var(--font-size-5);
    color: #fb3958;
    font-family: var(--font-medium), sans-serif;
    opacity: 1;
    max-height: 50px; /* Adjust based on your needs */
    transition: opacity 0.3s ease, max-height 0.3s ease-out;
    padding: 0 12px;
    margin: 4px;
}

.MobileTabletBrochureForm_error__fuYyp.MobileTabletBrochureForm_visible__TQWF5 {
    opacity: 1;
    max-height: 50px; /* Adjust based on your needs */
}

.MobileTabletBrochureForm_separator__Iqrkt {
    width: 1px;
    height: 100%;
    background-color: var(--primary-dark);
}

.MobileTabletBrochureForm_tabletPhoneInput__Www90 {
    border: 1.5px solid var(--primary-dark-01);
    margin-bottom: 20px;
}

.MobileTabletBrochureForm_tabletPhoneInput__Www90 .PhoneInput {
    padding: 16px 20px;
    border: 1.5px solid var(--primary-light-01);
    border-radius: 16px;
    transition: border-color 0.3s ease-out;
}

.MobileTabletBrochureForm_tabletPhoneInput__Www90 .PhoneInput--focus {
    border: solid 1.5px var(--primary-accent);
}

.MobileTabletBrochureForm_tabletPhoneInput__Www90 .PhoneInputInput {
    background-color: transparent;
    border: none;
    color: var(--primary-light);
    outline: none;
    width: 100%;
    height: 100%;
    padding: 0px 8px;
    font-size: var(--font-size-8);
    font-family: var(--font-medium), sans-serif;
}

.MobileTabletBrochureForm_tabletPhoneInput__Www90 .PhoneInputCountry {
    height: 100%;
    gap: 8px;
}

.MobileTabletBrochureForm_tabletPhoneInput__Www90 .PhoneInputCountrySelect {
    outline: none;
}

.MobileTabletBrochureForm_successMessage__WLLdA {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    row-gap: 10px;
    text-align: center;
    padding: 10px 0px;
}

.MobileTabletBrochureForm_successMessage__WLLdA button {
    position: absolute;
    top: -5%;
    right: 0;
    background-color: transparent;
    border: none;
    cursor: pointer;
}

.MobileTabletBrochureForm_successTitle__Uh9Zq {
    font-size: var(--font-size-4);
    font-family: var(--font-semi-bold), sans-serif;
    color: var(--primary-accent);
}

.MobileTabletBrochureForm_successText__5Ux2J {
    font-size: var(--font-size-8);
    font-family: var(--font-semi-bold), sans-serif;
    color: var(--primary-light);
}

.MobileTabletBrochureForm_successSubText__3jXgu {
    font-size: var(--font-size-4);
    font-family: var(--font-medium), sans-serif;
    color: var(--primary-light-06);
}

@media (max-width: 767px) {
    .MobileTabletBrochureForm_container__bFRsk {
        gap: 4px;
    }
    .MobileTabletBrochureForm_input__krJeL {
        border-radius: 16px;
        padding: 16px 12px;
        font-size: 16px;
    }

    .MobileTabletBrochureForm_select__0rWP6 {
        padding: 4px;
        font-size: 16px;
    }

    .MobileTabletBrochureForm_formButton__FrU4- {
        padding: 14px;
        font-size: var(--font-size-5);
    }

    .MobileTabletBrochureForm_selectWrapper__bcelS {
        padding: 10px 10px;
        margin-top: 6px;
        margin-bottom: 16px;
    }

    .MobileTabletBrochureForm_temporary__9wGq6 {
        padding: 10px 12px;
    }

    .MobileTabletBrochureForm_formButton__FrU4- {
        padding: 16px 20px;
    }

    .MobileTabletBrochureForm_tabletRow__aVJQa {
        flex-direction: column;
        align-items: unset;
        justify-content: unset;
    }

    .MobileTabletBrochureForm_tabletRow__aVJQa > input {
        width: unset;
    }
    .MobileTabletBrochureForm_tabletRow__aVJQa > div {
        width: unset;
    }

    .MobileTabletBrochureForm_phoneInputWrapper__VvFE8 {
        min-height: 50px;
    }

    .PhoneInputInput {
        font-size: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Form/MobileTabletBrochureForm/MobileTabletBrochureForm.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,2CAA2C;IAC3C,kBAAkB;IAClB,aAAa;IACb,6BAA6B;IAC7B,2BAA2B;IAC3B,2CAA2C;IAC3C,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,uCAAuC;IACvC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,2BAA2B;IAC3B,8CAA8C;IAC9C,6BAA6B;IAC7B,uCAAuC;IACvC,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;AACjC;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,2CAA2C;IAC3C,UAAU;IACV,gBAAgB,EAAE,+BAA+B;IACjD,uDAAuD;IACvD,eAAe;IACf,WAAW;AACf;;AAEA;IACI,UAAU;IACV,gBAAgB,EAAE,+BAA+B;AACrD;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,qCAAqC;AACzC;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,2BAA2B;IAC3B,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;IAC7B,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,6BAA6B;IAC7B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,8CAA8C;IAC9C,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,2CAA2C;IAC3C,8BAA8B;AAClC;;AAEA;IACI;QACI,QAAQ;IACZ;IACA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,6BAA6B;IACjC;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n}\n\n.input {\n    background-color: transparent;\n    border-radius: 16px;\n    border: 1.5px solid var(--primary-light-01);\n    padding: 16px 20px;\n    outline: none;\n    font-size: var(--font-size-8);\n    color: var(--primary-light);\n    font-family: var(--font-medium), sans-serif;\n    transition: border-color 0.3s ease-out;\n    flex-grow: 1;\n}\n\n.input:focus {\n    border-color: var(--primary-accent);\n}\n\n.inputWrapper {\n    background-color: transparent;\n    border-radius: 16px;\n    border: 1.5px solid var(--primary-dark);\n    display: flex;\n    align-items: center;\n}\n\n.selectWrapper {\n    background-color: transparent;\n    border-radius: 16px;\n    border: 1.5px solid var(--primary-dark);\n    padding: 16px 20px;\n    display: flex;\n    align-items: center;\n}\n\n.focused {\n    border-color: var(--primary-accent);\n    transition: border-color 0.3s ease-out;\n}\n\n.select {\n    background-color: transparent;\n    outline: none;\n    font-size: var(--font-size-8);\n    border: none;\n    width: 100%;\n    color: var(--primary-light);\n    font-family: var(--font-medium), sans-serif;\n}\n\n.rtl {\n    direction: rtl;\n}\n\n.formButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    color: var(--primary-light);\n    font-family: var(--font-semi-bold), sans-serif;\n    font-size: var(--font-size-5);\n    background-color: var(--primary-accent);\n    border-radius: 50px;\n    padding: 16px 20px;\n    cursor: pointer;\n    transition: all 0.3s ease-out;\n}\n\n.formButton:hover,\n.formButton:active {\n    background-color: var(--primary-accent-08);\n}\n\n.tabletRow {\n    display: flex;\n    width: 100%;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.tabletRow > div {\n    width: 49%;\n    display: flex;\n    flex-direction: column;\n}\n\n.error {\n    font-size: var(--font-size-5);\n    color: #fb3958;\n    font-family: var(--font-medium), sans-serif;\n    opacity: 1;\n    max-height: 50px; /* Adjust based on your needs */\n    transition: opacity 0.3s ease, max-height 0.3s ease-out;\n    padding: 0 12px;\n    margin: 4px;\n}\n\n.error.visible {\n    opacity: 1;\n    max-height: 50px; /* Adjust based on your needs */\n}\n\n.separator {\n    width: 1px;\n    height: 100%;\n    background-color: var(--primary-dark);\n}\n\n.tabletPhoneInput {\n    border: 1.5px solid var(--primary-dark-01);\n    margin-bottom: 20px;\n}\n\n.tabletPhoneInput :global(.PhoneInput) {\n    padding: 16px 20px;\n    border: 1.5px solid var(--primary-light-01);\n    border-radius: 16px;\n    transition: border-color 0.3s ease-out;\n}\n\n.tabletPhoneInput :global(.PhoneInput--focus) {\n    border: solid 1.5px var(--primary-accent);\n}\n\n.tabletPhoneInput :global(.PhoneInputInput) {\n    background-color: transparent;\n    border: none;\n    color: var(--primary-light);\n    outline: none;\n    width: 100%;\n    height: 100%;\n    padding: 0px 8px;\n    font-size: var(--font-size-8);\n    font-family: var(--font-medium), sans-serif;\n}\n\n.tabletPhoneInput :global(.PhoneInputCountry) {\n    height: 100%;\n    gap: 8px;\n}\n\n.tabletPhoneInput :global(.PhoneInputCountrySelect) {\n    outline: none;\n}\n\n.successMessage {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    row-gap: 10px;\n    text-align: center;\n    padding: 10px 0px;\n}\n\n.successMessage button {\n    position: absolute;\n    top: -5%;\n    right: 0;\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n}\n\n.successTitle {\n    font-size: var(--font-size-4);\n    font-family: var(--font-semi-bold), sans-serif;\n    color: var(--primary-accent);\n}\n\n.successText {\n    font-size: var(--font-size-8);\n    font-family: var(--font-semi-bold), sans-serif;\n    color: var(--primary-light);\n}\n\n.successSubText {\n    font-size: var(--font-size-4);\n    font-family: var(--font-medium), sans-serif;\n    color: var(--primary-light-06);\n}\n\n@media (max-width: 767px) {\n    .container {\n        gap: 4px;\n    }\n    .input {\n        border-radius: 16px;\n        padding: 16px 12px;\n        font-size: 16px;\n    }\n\n    .select {\n        padding: 4px;\n        font-size: 16px;\n    }\n\n    .formButton {\n        padding: 14px;\n        font-size: var(--font-size-5);\n    }\n\n    .selectWrapper {\n        padding: 10px 10px;\n        margin-top: 6px;\n        margin-bottom: 16px;\n    }\n\n    .temporary {\n        padding: 10px 12px;\n    }\n\n    .formButton {\n        padding: 16px 20px;\n    }\n\n    .tabletRow {\n        flex-direction: column;\n        align-items: unset;\n        justify-content: unset;\n    }\n\n    .tabletRow > input {\n        width: unset;\n    }\n    .tabletRow > div {\n        width: unset;\n    }\n\n    .phoneInputWrapper {\n        min-height: 50px;\n    }\n\n    :global(.PhoneInputInput) {\n        font-size: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MobileTabletBrochureForm_container__bFRsk`,
	"input": `MobileTabletBrochureForm_input__krJeL`,
	"inputWrapper": `MobileTabletBrochureForm_inputWrapper__RF3CZ`,
	"selectWrapper": `MobileTabletBrochureForm_selectWrapper__bcelS`,
	"focused": `MobileTabletBrochureForm_focused__gVllA`,
	"select": `MobileTabletBrochureForm_select__0rWP6`,
	"rtl": `MobileTabletBrochureForm_rtl__Uiad5`,
	"formButton": `MobileTabletBrochureForm_formButton__FrU4-`,
	"tabletRow": `MobileTabletBrochureForm_tabletRow__aVJQa`,
	"error": `MobileTabletBrochureForm_error__fuYyp`,
	"visible": `MobileTabletBrochureForm_visible__TQWF5`,
	"separator": `MobileTabletBrochureForm_separator__Iqrkt`,
	"tabletPhoneInput": `MobileTabletBrochureForm_tabletPhoneInput__Www90`,
	"successMessage": `MobileTabletBrochureForm_successMessage__WLLdA`,
	"successTitle": `MobileTabletBrochureForm_successTitle__Uh9Zq`,
	"successText": `MobileTabletBrochureForm_successText__5Ux2J`,
	"successSubText": `MobileTabletBrochureForm_successSubText__3jXgu`,
	"temporary": `MobileTabletBrochureForm_temporary__9wGq6`,
	"phoneInputWrapper": `MobileTabletBrochureForm_phoneInputWrapper__VvFE8`
};
export default ___CSS_LOADER_EXPORT___;
